import React from "react"
import { ActivityIndicator, View, ViewStyle } from "react-native"

import IonIcons from "@expo/vector-icons/Ionicons"
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from "react-native-reanimated"

import { StepStatus } from "src/context/SidekickProgressContext"
import { useAppTheme } from "src/hooks/useAppTheme"
import { ThemedStyle } from "src/theme"

const ICON_SIZE = 20

interface ProgressStepIconProps {
  status: StepStatus
}

export const ProgressStepIcon = ({ status }: ProgressStepIconProps) => {
  const { theme, themed } = useAppTheme()
  const rotation = useSharedValue(0)

  React.useEffect(() => {
    if (status === "in_progress") {
      rotation.value = withRepeat(
        withTiming(360, { duration: 1000, easing: Easing.linear }),
        -1,
        false,
      )
    } else {
      rotation.value = 0
    }
  }, [status, rotation])

  const spinStyle = useAnimatedStyle(() => ({
    transform: [{ rotate: `${rotation.value}deg` }],
  }))

  if (status === "complete") {
    return <IonIcons name="checkmark-circle" size={ICON_SIZE} color={theme.colors.tint} />
  }

  if (status === "in_progress") {
    return (
      <View style={themed($spinnerWrapper)}>
        <ActivityIndicator size="small" color={theme.colors.tint} />
      </View>
    )
  }

  // pending — thin ring
  return <View style={themed($pendingRing)} />
}

const $spinnerWrapper: ThemedStyle<ViewStyle> = () => ({
  width: ICON_SIZE,
  height: ICON_SIZE,
  justifyContent: "center",
  alignItems: "center",
})

const $pendingRing: ThemedStyle<ViewStyle> = ({ colors }) => ({
  width: ICON_SIZE,
  height: ICON_SIZE,
  borderRadius: ICON_SIZE / 2,
  borderWidth: 1.5,
  borderColor: colors.textDim,
})
